import { useContext } from 'react';
import { ReportContext } from '../../../context/ReportContext';
import SimpleDataGrid from '../../Tables/SimpleDataGrid';
import SimpleDataGridItem from '../../Tables/SimpleDataGridItem';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

const UserStressAggregate = () => {
    const { reportData } = useContext(ReportContext);

    return (
        <div className="space-y-6">
            <SimpleDataGrid>
                <SimpleDataGridItem
                    label="Total Completed:"
                    value={reportData.totalCompleted}
                />
                <SimpleDataGridItem
                    label="Average Cognitive Score:"
                    value={reportData.averageCognitive?.toFixed(1)}
                />
                <SimpleDataGridItem
                    label="Average Behavioral Score:"
                    value={reportData.averageBehavioral?.toFixed(1)}
                />
                <SimpleDataGridItem
                    label="Average Emotional Score:"
                    value={reportData.averageEmotional?.toFixed(1)}
                />
                <SimpleDataGridItem
                    label="Average Avoidance Score:"
                    value={reportData.averageAvoidance?.toFixed(1)}
                />
                <SimpleDataGridItem
                    label="Average Appraisal Score:"
                    value={reportData.averageAppraisal?.toFixed(1)}
                />
                <SimpleDataGridItem
                    label="Average Stress Score:"
                    value={reportData.averageStressScore?.toFixed(1)}
                />
            </SimpleDataGrid>

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report provides aggregate statistics for financial stress
                    assessments completed by users during the selected time period and
                    filters. The scores measure different dimensions of financial stress
                    and coping strategies. A value from 0 to 4 is low, 5 is moderate, and
                    6 to 10 is high. For the cumulative score, a value of 0 to 20 is low,
                    21 to 24 is moderate, and 25 to 40 is high.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Total Completed">
                    The total number of financial stress assessments completed by users.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Average Cognitive Score">
                    Average score measuring how financial stress impacts users thoughts.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Average Behavioral Score">
                    Average score measuring how financial stress affects users actions.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Average Emotional Score">
                    Average score measuring how financial stress influences users
                    feelings.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Average Avoidance Score">
                    Average score measuring how users deal with financial stress by
                    avoiding thinking about it.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Average Appraisal Score">
                    Average score measuring how users deal with financial stress by
                    reviewing the positive and negative impacts.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Average Stress Score">
                    Overall average financial stress score combining all dimensions of
                    stress measurement.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserStressAggregate;
